import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchProducts } from 'lib/shopify';

const ProductsContext = createContext();

export function ProductsProvider({ children }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      try {
        const shopifyProducts = await fetchProducts();
        if (!cancelled) {
          setProducts(shopifyProducts);
          setLoading(false);
        }
      } catch (err) {
        console.warn('Failed to fetch from Shopify:', err.message);
        if (!cancelled) {
          setLoading(false);
          setError(err.message);
        }
      }
    }
    load();
    return () => { cancelled = true; };
  }, []);

  return (
    <ProductsContext.Provider value={{ products, loading, error }}>
      {children}
    </ProductsContext.Provider>
  );
}

export function useProducts() {
  return useContext(ProductsContext);
}
